import { createApi } from '@reduxjs/toolkit/query/react';
import { Endpoints } from 'src/config';
import { apiHelper } from 'src/utils/apiHelper';
import { baseQuery, tagType } from 'src/utils/baseQuery';

const tags = {
  list: 'course-level-list',
};

const CourseLevelApi = createApi({
  reducerPath: 'course-level-api',
  baseQuery: baseQuery(),
  tagTypes: [tags.list],
  endpoints: (builder) => ({
    getCourseLevels: builder.query({
      providesTags: [tagType(tags.list)],
      query: (body) => apiHelper(Endpoints.courseLevels.list, body),
    }),
    createCourseLevel: builder.mutation({
      invalidatesTags: [tagType(tags.list)],
      query: (body) => ({
        url: Endpoints.courseLevels.create,
        method: 'post',
        body: body,
      }),
    }),
    editCourseLevel: builder.mutation({
      invalidatesTags: [tagType(tags.list)],
      query: (body) => ({
        url: Endpoints.courseLevels.edit,
        method: 'post',
        body: body,
      }),
    }),
    deleteCourseLevel: builder.mutation({
      invalidatesTags: [tagType(tags.list)],
      query: (body) => ({
        url: Endpoints.courseLevels.delete,
        method: 'post',
        body,
      }),
    }),
  }),
});

export const {
  useGetCourseLevelsQuery,
  useCreateCourseLevelMutation,
  useEditCourseLevelMutation,
  useDeleteCourseLevelMutation,
} = CourseLevelApi;
export { CourseLevelApi };
